import { render, staticRenderFns } from "./comp_Button.vue?vue&type=template&id=2c599f8e&scoped=true&"
import script from "./comp_Button.vue?vue&type=script&lang=js&"
export * from "./comp_Button.vue?vue&type=script&lang=js&"
import style0 from "./comp_Button.vue?vue&type=style&index=0&id=2c599f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c599f8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
